export default __webpack_public_path__ + "static/media/finalBooking.d73a872f.webp";